<template>
  <div>
    <template v-if="routeMatchesComponent()">
      <div class="flex flex-wrap white-bg p3 m3">
        <iframe
          v-if="!loading"
          id="preference-center"
          name="preference-center"
          class="flex col-12"
          style="height:800px;"
          :src="newsletterSrc"
          frameBorder="0"
        ></iframe>

        <!-- <span class="flex col-12 block h4n bold mt2">Notifications de la communauté</span>
        <form :action="communityUrl" target="_blank" class="flex col-12">
          <div class="flex justify-center col-12">
            <Button
              text="Modifier Les Réglages"
              class="center mt2 col-12 md-col-6 lg-col-4 submit"
              btn-color="blue"
            />
          </div>
        </form> -->
      </div>
    </template>
    <router-view v-else />
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getCurrentInstance, computed, ref, onBeforeMount } from 'vue';
import Button from '@/components/elements/Button';
import { isRecette, routeIsCurrentComponent } from '@/mixins/utils';
import { getNewsletterSettings } from '@/mixins/requests';

export default {
  components: { Button },
  setup () {
    const loading = ref(true);
    const route = useRoute();
    const store = useStore();
    const newsletterSettings = ref({});

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    const communityBaseUrl = isRecette(window.location.href);
    const communityUrl = computed(() => `${communityBaseUrl}/t5/user/myprofilepage/tab/user-subscriptions%3Anotification-settings`);

    const newsletterSrc = computed(() => `${newsletterSettings.value.CLOUDFORMATION_PINPOINT_DOMAIN}?pid=${newsletterSettings.value.PINPOINT_ID}&uid=${newsletterSettings.value.userEndpoint}&h=${newsletterSettings.value.newsletterSHA256}`);

    onBeforeMount(async () => {
      newsletterSettings.value = await getNewsletterSettings().then(response => response.data).catch(err => console.error(err));
      loading.value = false;
    });

    return {
      route,
      store,
      communityUrl,
      routeMatchesComponent,
      newsletterSrc,
      loading
    };
  }
};
</script>

<style>
.input-height {
  height: 50px;
}

@media (max-width: 40em) {
  .my-profile-text {
    text-align: center;
  }
}
</style>
